var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3541 13.056V21.798C28.3541 25.4147 25.4097 28.3542 21.7916 28.3542H18.1458V21.7963C18.1458 19.7888 16.5095 18.1565 14.4999 18.1565C12.4903 18.1565 10.8541 19.7888 10.8541 21.7963V28.3542H7.20825C3.59013 28.3542 0.645752 25.4132 0.645752 21.798V13.056C0.645752 11.0617 1.53824 9.19876 3.09283 7.94702L10.3845 2.08362C12.7674 0.166624 16.228 0.166624 18.6139 2.08362L25.9055 7.94702C27.4616 9.19876 28.3541 11.0602 28.3541 13.056Z",
    fill: "#C2C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.7ce4061d8abae2c70a945dda7a48eba1.svg";
export { ForwardRef as ReactComponent };